import { render } from "./addArea.vue?vue&type=template&id=e06ae984"
import script from "./addArea.vue?vue&type=script&lang=js"
export * from "./addArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__